import { useCallback, useMemo } from "react";
import { formatRelative, intlFormat } from "date-fns";
import useDateFnsCurrentLocale from "./useDateFnsCurrentLocale";

// These are very similar to luxon's shorthand format options
export const DATE_SHORT = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};
export const DATE_MED = {
  year: "numeric",
  month: "short",
  day: "numeric",
};
export const DATE_MED_WITH_WEEKDAY = {
  year: "numeric",
  month: "short",
  day: "numeric",
  weekday: "short",
};
export const DATE_FULL = {
  year: "numeric",
  month: "long",
  day: "numeric",
};
export const DATE_FULL_WITH_WEEKDAY = {
  year: "numeric",
  month: "long",
  day: "numeric",
  weekday: "long",
};
export const TIME_SIMPLE = {
  hour: "numeric",
  minute: "numeric",
  hour12: true,
};
export const TIME_WITH_SECONDS = {
  hour: "numeric",
  minute: "numeric",
  seconds: "numeric",
  hour12: true,
};
export const TIME_24_SIMPLE = {
  hour: "numeric",
  minute: "numeric",
  hour12: false,
};
export const TIME_24_WITH_SECONDS = {
  hour: "numeric",
  minute: "numeric",
  seconds: "numeric",
  hour12: false,
};
export const DATETIME_SHORT = {
  ...DATE_SHORT,
  ...TIME_24_SIMPLE,
};
export const DATETIME_MED = {
  ...DATE_MED,
  ...TIME_24_SIMPLE,
};
export const DATETIME_MED_WITH_WEEKDAY = {
  ...DATE_MED,
  ...TIME_24_SIMPLE,
};
export const DATETIME_FULL = {
  ...DATE_FULL,
  ...TIME_24_SIMPLE,
};
export const DATETIME_SHORT_WITH_SECONDS = {
  ...DATE_SHORT,
  ...TIME_24_WITH_SECONDS,
};
export const DATETIME_MED_WITH_SECONDS = {
  ...DATE_MED,
  ...TIME_24_WITH_SECONDS,
};
export const DATETIME_MED_WITH_WEEKDAY_WITH_SECONDS = {
  ...DATE_MED_WITH_WEEKDAY,
  ...TIME_24_WITH_SECONDS,
};
export const DATETIME_FULL_WITH_SECONDS = {
  ...DATE_FULL,
  ...TIME_24_WITH_SECONDS,
};
export const DATETIME_FULL_WITH_WEEKDAY_WITH_SECONDS = {
  ...DATE_FULL_WITH_WEEKDAY,
  ...TIME_24_WITH_SECONDS,
};

export default function useDateFnsFormatIntlLocale() {
  const { currentLocale } = useDateFnsCurrentLocale();
  const formatWithLocale = useCallback(
    (date: Date | number, options?: Record<string, unknown>) =>
      intlFormat(date, options, { locale: currentLocale.code }),
    [currentLocale]
  );
  return { currentLocale, formatWithLocale };
}
